export const studentHousing = [
  {
    city: 'Irvine',
    neighborhood: 'UCI Area',
    university: 'UC Irvine',
    keyword1: 'Off Campus',
    keyword2: 'Student Housing & Co-living'
  },
  {
    city: 'Los Angeles',
    neighborhood: 'USC',
    university: 'USC',
    keyword1: 'Off Campus',
    keyword2: 'Student Housing & Co-living'
  },
  {
    city: 'Pittsburgh',
    neighborhood: 'Squirrel Hill',
    university: 'CMU',
    keyword1: 'Off Campus',
    keyword2: 'Student Housing & Co-living'
  },
  {
    city: 'Pittsburgh',
    neighborhood: 'Oakland',
    university: 'CMU',
    keyword1: 'Off Campus',
    keyword2: 'Student Housing & Co-living'
  },
  {
    city: 'Seattle',
    neighborhood: 'University District',
    university: 'UW',
    keyword1: 'Off Campus',
    keyword2: 'Student Housing & Co-living'
  },
  {
    city: 'Philadelphia',
    neighborhood: 'University City',
    university: 'UPenn|Drexel',
    keyword1: 'Off Campus',
    keyword2: 'Student Housing & Co-living'
  },
  {
    city: 'Philadelphia',
    neighborhood: 'Temple University',
    university: 'Temple University',
    keyword1: 'Off Campus',
    keyword2: 'Student Housing & Co-living'
  },
  {
    city: 'Tucson',
    neighborhood: 'UA',
    university: 'University of Arizona',
    keyword1: 'Off Campus',
    keyword2: 'Student Housing & Co-living'
  },
  {
    city: 'Chicago',
    neighborhood: 'UIC',
    university: 'University of Illinois Chicago',
    keyword1: 'Off Campus',
    keyword2: 'Student Housing & Co-living'
  },
  {
    city: 'Berkeley',
    neighborhood: 'Downtown Berkeley',
    university: 'University of California',
    keyword1: 'Off Campus',
    keyword2: 'Student Housing & Co-living'
  }
] as const

export const BED_ROOMS_INFO_LIST = [
  { apartmentType: 0, label: 'Studio', key: 'studio', path: 'studio' },
  { apartmentType: 1, label: '1 Bedroom', key: 'oneBedroom', path: '1-bedroom' },
  { apartmentType: 2, label: '2 Bedrooms', key: 'twoBedroom', path: '2-bedroom' },
  { apartmentType: 3, label: '3 Bedrooms', key: 'threeBedroom', path: '3-bedroom' }
] as const

export const shouldStudent = (areaName: string) =>
  studentHousing.some(({ neighborhood }) => neighborhood === areaName)
